import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import AccessDenied from '../../components/AccessDenied';
import { useModuleAccess } from '../../utils/useModuleAccess';
import { LiveCountersPanel } from '../MastersManagement';

/* Buffet → Live Counters: the station register, surfaced where the people who
   use it live. The counters are MASTER DATA (they also appear under Settings →
   Master Data → Live Counters, the same panel), but the person defining a
   tandoor or a chaat counter is the one building buffets — so the register
   sits in the Buffet group too rather than only behind Settings. Same
   master_data permission either way: one register, two doors, one door key. */
export default function LiveCountersPage() {
  const access = useModuleAccess('master_data');
  if (!access.canView) {
    return <AccessDenied perm="master_data.view" what="Live Counters" />;
  }

  return (
    <div className="p-6 h-full flex flex-col">
      <header className="mb-5">
        <h1 className="font-display text-3xl font-semibold leading-none tracking-tight text-foreground">
          Live Counters
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          The station register every buffet picks from — a tandoor, a dosa griddle, a pasta
          bar — each defined once with the ingredients it cooks through.
        </p>
      </header>

      {!access.canEdit && (
        <div className="mb-4 rounded-md border border-warning/30 bg-warning-soft px-4 py-2.5 text-sm text-warning">
          <strong>Read-only access.</strong> Your role can view live counters but cannot change them.
        </div>
      )}

      <Card className="flex-1 min-h-0 flex flex-col">
        <CardContent className="flex-1 min-h-0 flex flex-col p-5">
          <LiveCountersPanel canEdit={access.canEdit} canCreate={access.canCreate} />
        </CardContent>
      </Card>
    </div>
  );
}
